import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { ApplicationInvitationUpdateInput } from 'types/api'
import type { BaseParams } from 'types/utils'

export function usePatchInvitation() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError() // Added usage

  async function updateInvitation({
    id,
    body
  }: BaseParams<
    [ApplicationInvitationUpdateInput, ApplicationInvitationUpdateInput],
    'PATCH'
  >) {
    const res = await apiClient.patch<ApplicationInvitationUpdateInput>(
      `${SNA_PREFIX}invitations/${id}/`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: updateInvitation,
    onSuccess: (data, variables) => {
      variables?.params?.onSuccess?.(data)
      toast.success({ message: t('invitationUpdated') })
      queryClient.invalidateQueries({ queryKey: ['invitation'] })
    },
    onError // Replaced inline function
  })
}
